module.exports = __webpack_public_path__ + "img/9788932019840.b83c17e2.jpg";